
import { useState, useEffect } from 'react';

export default function Footer() {
  const [visitorCount, setVisitorCount] = useState(0);

  useEffect(() => {
    // 訪問者数を取得・更新
    const updateVisitorCount = () => {
      const currentCount = localStorage.getItem('lp-visitor-count');
      const lastVisit = localStorage.getItem('last-visit-time');
      const now = Date.now();
      
      // 初回訪問または24時間以上経過した場合は新しい訪問者としてカウント
      if (!lastVisit || (now - parseInt(lastVisit)) > 24 * 60 * 60 * 1000) {
        const newCount = currentCount ? parseInt(currentCount) + 1 : 1;
        localStorage.setItem('lp-visitor-count', newCount.toString());
        localStorage.setItem('last-visit-time', now.toString());
        setVisitorCount(newCount);
      } else {
        setVisitorCount(currentCount ? parseInt(currentCount) : 0);
      }
    };

    // 1時間ごとに3ずつカウントアップする機能
    const autoIncrement = () => {
      const lastAutoIncrement = localStorage.getItem('last-auto-increment');
      const now = Date.now();
      
      if (!lastAutoIncrement || (now - parseInt(lastAutoIncrement)) >= 60 * 60 * 1000) {
        const currentCount = localStorage.getItem('lp-visitor-count');
        const newCount = currentCount ? parseInt(currentCount) + 3 : 3;
        localStorage.setItem('lp-visitor-count', newCount.toString());
        localStorage.setItem('last-auto-increment', now.toString());
        setVisitorCount(newCount);
      }
    };

    updateVisitorCount();
    autoIncrement();

    // 1時間ごとに自動インクリメントをチェック
    const interval = setInterval(() => {
      autoIncrement();
    }, 60 * 60 * 1000); // 1時間ごと

    return () => clearInterval(interval);
  }, []);

  const formatVisitorCount = (count: number) => {
    return count.toLocaleString('ja-JP');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="https://static.readdy.ai/image/2164e1b7672604a4b6f40cc0551a0838/eb8ff83a3546fe57070bf812bafc35d3.jfif"
              alt="ZOLLER"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 mb-4">
              ツールプリセッターのリーディングカンパニー
            </p>
            <div className="text-sm text-gray-400">
              ZOLLER Japan | 国内サポート・導入実績多数
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">対応コントローラ</h3>
            <ul className="text-gray-300 space-y-2">
              <li>• Fanuc</li>
              <li>• Mitsubishi</li>
              <li>• Heidenhain</li>
              <li>• Siemens</li>
              <li>• その他多数対応</li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">お問い合わせ</h3>
            <div className="text-gray-300 space-y-2">
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <span>event@zoller-jp.com</span>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center md:items-end">
            <div className="bg-yellow-400 text-black px-6 py-4 rounded-lg text-center mb-4">
              <div className="flex items-center justify-center mb-2">
                <i className="ri-eye-line text-xl mr-2"></i>
                <span className="text-sm font-medium">累計訪問者数</span>
              </div>
              <div className="text-3xl font-bold">
                {formatVisitorCount(visitorCount)}
              </div>
              <div className="text-xs mt-1">人</div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm">
            © 2024 ZOLLER Japan. All rights reserved.
          </div>
          <div className="text-gray-400 text-sm mt-4 md:mt-0">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-yellow-400 transition-colors">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
